export default __webpack_public_path__ + "maps-examples-fly-to-thumbnail-960-2f97c5140e8b3510922efbceaeadd2c4.webp";